import { useEffect, useState } from "react";
import FormComp from "../../../Componentes/FormComp";
import Overlay from "../../../Componentes/Overlay";
import Formulario from "../../../Componentes/Utils/Formulario";
import Modal from "../../../Componentes/Utils/Modal";
import useApi from "../../../hooks/useApi";
const ModalAddConteudo = ({ modo, item, close, funcao, idParent, onSuccess }) => {
    const api = useApi();


    const [ conteudo, setConteudo ] = useState("")
    const [ loading, setLoading ] = useState( false );

    useEffect(() => {

        if( modo === "edit" && item ){

            setConteudo( item.conteudo )

        }

    }, [ modo, item ])

    const handleChange = ( e ) => {

        let valor = e.target.value.toUpperCase()
        setConteudo( valor )

    }

    const handleSubmit = async ( e ) => {

        e.preventDefault();

        if (!conteudo.trim()) {
            alert("O conteúdo não pode estar vazio.");
            return;
        }

        setLoading( true )
        
        try{

            const formData = new FormData();
            formData.append("conteudo", conteudo)
            formData.append("funcao", funcao)

            if( modo === 'edit' && item ){

                formData.append("id", item.identifier)

            }

            if( idParent ){

                formData.append("id_pai", idParent )

            }

            const url = "/Painel/API/Treinamentos/SalvarConteudoOs/"
            const { data } = await api.post( url, formData, { withCredentials: true });

            console.log( data )
            if( onSuccess ) onSuccess();
            close();

        }catch( e ){

            console.log( e )

        }finally{

            setLoading( false ) 

        }

    }

    return(
        <Overlay state={ true } >
            <Modal header={ true } size="md" close={ close } >
                <Formulario onSubmit={( e ) => handleSubmit( e )} >
                    <FormComp
                        title="CONTEÚDO"
                        type="text"
                        valor={ conteudo }
                        changeFunc={( e ) => handleChange( e )}
                        disabled={ loading }
                    />
                    <FormComp
                        type="submit"
                        valor={ loading ? "SALVANDO..." : "SALVAR" }
                        disabled={ loading }
                    />
                </Formulario>
            </Modal>
        </Overlay>
    )

}

export default ModalAddConteudo;